var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.data),function(item,index){return _c('tr',{key:item.name},[_c('td',[_c('span',{staticClass:"point",style:({ color: _vm.getNextDiagramColor(index) })},[_vm._v("●")]),_vm._v(_vm._s(item.name)+" ")]),_c('td',[_vm._v(_vm._s(item.visits))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }